
import { defineComponent } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default defineComponent({
  name: 'AppFlashNotifications',
  components: { FontAwesomeIcon },
})
